import React, {useContext, useState} from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import style from './CustomizeBreakpoint.module.css';
import {AppContext} from '../../../../Resources/CanvasContextFile';
import {focusElement} from "../../../../Resources/globalFunctions"
import Cross from "../../../../Icons/Cross";
import ToggleTick from "../../../../Icons/ToggleTick";
import Web from "../../../../Icons/Web";
import Tab from "../../../../Icons/Tab";
import Mobile from "../../../../Icons/Mobile";
import Delete from "../../../../Icons/DeleteWhiteIcon";
import Edit from "../../../../Icons/EditIcon";
import GreyCross from "../../../../Icons/GreyCross.svg";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';
import {useDispatch,addContexts,useSelector} from "../../../../Redux";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { useEffect } from 'react';
import { Popover, useMediaQuery } from '@material-ui/core';
import { GetStateFromData } from '../../../CustomHooks/CustomHooks';
import BreakpointsDevices from '../BreakpointDevices/BreakpointsDevices';
import SvgDeleteWhiteIcon from '../../../../Icons/DeleteWhiteIcon';
// import useFocusTrap from '../../../../useFocusTrap.js';


const useStyles = makeStyles((theme) => ({
  popoverRoot: { position: 'absolute !important' },
  paper: {
    top: "43px !important",
    left: "-135px !important",
    minWidth: "277px",
    width: '277px',
    padding: "10px 5px",
    position: "absolute",
    maxHeight: '220px'
  },
  tooltip: {
    // maxWidth: "360px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15
  },
  root:{
    margin: "0px !important"
  },
  root1 : {
    margin : '0px !important',
    height : '100% !important',
    width: "35px",
    border: style => style.open ? "1px solid #0072C6" : "",
    backgroundColor: style => style.open ? "#E5F1F9" : "",

    "&:hover": { backgroundColor: "unset" },
    "&:focus": { backgroundColor: "unset !important" },

    "& .MuiIconButton-label": {
      width: "100%",
      height: "100%",
      padding: "0 !important",
    },

    "& .MuiSvgIcon-root": {
      width: "100%",
      height: "65%",

      "& path": {
        fill: style => style.open ? "#0072C6" : "#606060"
      }
    }
  }
}));


export default function CustomizeBreakpoint(props) {
  // const trapRef = useFocusTrap();

  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const matches = useMediaQuery('(min-width: 1181px)');
  const { t } = useTranslation(['styles', 'translation']);
  
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
	const classes = useStyles({ open });
  const [selectedIndex, setSelectedIndex]  = useState();
  const [selectedIndexAfterEdit, setSelectedIndexAfterEdit]  = useState();
  
  const [changeInputValueOfBox, setChangeInputValueOfBox] = useState(false);

  const [startValueInput, setStartValueInput] = useState(false);
  const [endValueInput, setEndValueInput] = useState(false);
  const [startValueOfBox, setStartValueOfBox] = useState();
  const [endValueOfBox, setEndValueOfBox] = useState();
  const [change, setChange] = useState(false);
  const [edit, setEdit] = useState(false);
  const [currentInputValue, setCurrentInputValue] = useState()
  const [inputInRange, setInputInRange] = useState(true)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex();
    setSelectedIndexAfterEdit();
  };

    // const { updateJson, formState2 } = useContext(AppContext);
    const contexts = GetStateFromData(props.containerId);
 



    
  const {updateJson,formState2, showAlertConfirmNotifications}=contexts.contexts;

  const { updatedComponentInFormState, removeAndUpdateComponentInFormState,saveFormState} =updateJson;
   
  var deviceWeb = <><Web/></>;
  var deviceTab = <><Tab/></>;
  var deviceMobile = <><Mobile/></>;

  var devicesJson = [
    {optionIcon : deviceWeb},
    {optionIcon : deviceTab},
    {optionIcon : deviceMobile},
  ];


 
  if(props.formdata &&  props.formdata.style && props?.formdata?.style["Breakpoints"]===undefined){
    props.formdata.style["Breakpoints"]=[
      {"StartValue":"1000","EndValue":"1250","device":"Desktop"},
      {"StartValue":"750","EndValue":"1000","device":"Tab"},
      {"StartValue":"320","EndValue":"750","device":"Mobile"}
    ]
    updatedComponentInFormState();
  }
  
 
  

  function selectDeviceHandler(index){
    setSelectedIndex(index);
    // setSelectedIndexAfterEdit();
  }

  if(props.formdata && props.formdata.style && props.formdata.style["Breakpoint"]===undefined)
  {
    if(props.formdata && props.formdata.style){
        // formState2.style["Breakpoint"]="njiop"
        // props.formdata.style["Breakpoint"]={
        //     "Desktop":"",
        //     "Tab":"",
        //     "Mobile":""
        // }
        // props.formdata.style["Breakpoint"]["Desktop"]={"StartValu":"1000","EndValu":"EndPoint"}
        //  props.formdata.style["Breakpoint"]["Tab"]={"StartValu":"750","EndValu":"1000"}
        // props.formdata.style["Breakpoint"]["Mobile"]={"StartValu":"320","EndValu":"720"}


        //  props.formdata.style["Breakpoint"]={
        //       "Desktop":{"StartValue":"1000","EndValue":"1250"},
        //       "Tab":{"StartValue":"750","EndValue":"1000"},
        //       "Mobile":{"StartValue":"320","EndValue":"750"}
        //  }

      props.formdata.style["Breakpoint"]={
        "Desktop":{"StartValue":"769","EndValue":"1250"},
        "Tab":{"StartValue":"481","EndValue":"768"},
        "Mobile":{"StartValue":"320","EndValue":"480"}
      }
    }
  }

  useEffect(()=>{
    let breakpoint = {};
    for(let i=0; i<props?.formdata?.style?.Breakpoints?.length; i++ ){
      breakpoint[props?.formdata?.style?.Breakpoints[i]["device"]] =  props?.formdata?.style?.Breakpoints[i];
    }
    if(props?.formdata?.style){
      props.formdata.style.Breakpoint = breakpoint;
    }

  },[props?.formdata?.style?.Breakpoints, change])


  function deleteDevice(index)
  {
    let breakpoints = props.formdata.style["Breakpoints"];
    if(index === 0){
      breakpoints[index+1].EndValue = '2000';
    } else if(index !== breakpoints.length-1){
      breakpoints[index+1].EndValue = breakpoints[index].EndValue;
    }
    breakpoints.splice(index, 1);
    
    if(props?.formdata?.style?.["Breakpoint"]?.["Custom"]){
      delete props.formdata.style["Breakpoint"]["Custom"];
    }
    
    setSelectedIndexAfterEdit();
    setSelectedIndex();
    updatedComponentInFormState();
    setChange(!change);
  }

  function editPixelForDevice(value, index){
    setSelectedIndexAfterEdit(index);
    setStartValueOfBox(value);
    setSelectedIndex();
    setEdit(true)
  }


  function addBreakPoint(){
    var length = props.formdata.style && props.formdata.style["Breakpoints"].length;
    var Custom = "Custom" + (length+1);

    props.formdata.style["Breakpoints"][length]={"StartValue":"320"}
    // setStartValueOfBox(320);
    
    setSelectedIndexAfterEdit(length);
    setSelectedIndex();
    updatedComponentInFormState();
  }

  function cancelCustom(){
    setSelectedIndex();
    setSelectedIndexAfterEdit();
  }

  function handleInputForSmallValue(event,index){
    if(Number(event.target.value) >= 320 && Number(event.target.value) <= 10000 ){
      setChangeInputValueOfBox(true);
      setStartValueInput(true);
      setStartValueOfBox(event.target.value);
    } 
    else {
      setChangeInputValueOfBox(true);
      setStartValueInput(true);
      setStartValueOfBox(320);
      setSelectedIndexAfterEdit(index);
      setCurrentInputValue(event.target.value)
      //customalert
      // alert("Value must be between 320 - 10000");
      showAlertConfirmNotifications({
        'open':true,
        'showConfirm':'showNotification',
        'alertType':'error',
        'alertContentKey':"BreakpointRange"
      });
    }
    
    // props.formdata.style["Breakpoint"][content]["StartValue"]=event.target.value;
    // updatedComponentInFormState();

  }

  function handleInputForLargeValue(event,content){
    setChangeInputValueOfBox(true);
    setEndValueInput(true);
    setEndValueOfBox(event.target.value);

    // props.formdata.style["Breakpoint"][content]["EndValue"]=event.target.value;
    // updatedComponentInFormState();
  }

  const handleInputChange = (event) => {
    if(/^[0-9]*$/u.test(event.target.value) || event.target.value === "") {
      setChangeInputValueOfBox(true);
    if(Number(event.target.value) < 320 || Number(event.target.value) > 10000){
      setInputInRange(false)
      setStartValueOfBox(event.target.value);

      showAlertConfirmNotifications({
        'open':true,
        'showConfirm':'showNotification',
        'alertType':'error',
        'alertContentKey':"BreakpointRange"
      });
    }else{
      setInputInRange(true)
      setStartValueOfBox(event.target.value);
      }
    }
  }

  function doneHandler(event, index){
    // if(startValueInput){
    //   props.formdata.style["Breakpoints"][index]["StartValue"]=startValueOfBox;
    // }
    let breakpoints = props?.formdata?.style?.Breakpoints;
    let breakpoint = props?.formdata?.style?.Breakpoint;

    // breakpoints.splice(selectedIndexAfterEdit, 1);
    breakpoints.pop();
    let newBreakpoint = {
      "StartValue" : startValueOfBox,
      "device" : "Custom"
    }
    let customBreakPoint = {
      "StartValue" : startValueOfBox
    }
    let isLast = true;
    let insertIndex = 0;
    // if(startValueOfBox >= 1000){
    //   newBreakpoint["device"] = "Desktop";
    // } else if(startValueOfBox >= 750){
    //   newBreakpoint["device"] = "Tab";
    // } else {
    //   newBreakpoint["device"] = "Mobile";
    // }

    for(let i=0; i<breakpoints.length; i++){
      if(i===0 && parseInt(breakpoints[i]["StartValue"]) < parseInt(startValueOfBox)){
        newBreakpoint["EndValue"] = '2000';
        customBreakPoint["EndValue"] = '2000';
        breakpoints[i]["EndValue"] = newBreakpoint["StartValue"]; 
        isLast = false;
        insertIndex = i;
        break;
      } else if(i!==0 && parseInt(breakpoints[i]["StartValue"]) < parseInt(startValueOfBox)){
        newBreakpoint["EndValue"] = breakpoints[i]["EndValue"];
        customBreakPoint["EndValue"] = breakpoints[i]["EndValue"];
        breakpoints[i]["EndValue"] = newBreakpoint["StartValue"]; 
        isLast = false;
        insertIndex = i;
        break;
      }
    }
    if(isLast){
      newBreakpoint["EndValue"] = breakpoints[breakpoints.length-1]["StartValue"];
      customBreakPoint["EndValue"] = breakpoints[breakpoints.length-1]["StartValue"];
      breakpoints.push(newBreakpoint);
    } else {
      breakpoints.splice(insertIndex, 0, newBreakpoint);
    }
    // if(index !== 0 && edit){
    //   breakpoints[index]["EndValue"] = breakpoints[index-1]["StartValue"];
    //   setEdit(false)
    // }
    breakpoint = {...breakpoint, "Custom":customBreakPoint}

    updatedComponentInFormState(props.formdata.id, props.formdata);
    setChange(!change)
    

    
    // if(endValueInput)
    // {
    //   props.formdata.style["Breakpoint"][content]["EndValue"]=endValueOfBox;
    // }
    
    // if(index===0){
    //   if(startValueInput)
    //   {
    //     props.formdata.style["Breakpoint"]["Tab"]["EndValue"]=startValueOfBox; 
    //   }
    // }

    // if(index===1){
    //   if(startValueInput)
    //   {
    //     props.formdata.style["Breakpoint"]["Mobile"]["EndValue"]=startValueOfBox; 
    //   }

    //   if(endValueInput){
    //     props.formdata.style["Breakpoint"]["Desktop"]["StartValue"]=endValueOfBox;
    //   }
    // }

    // if(index===2){
    //   if(endValueInput){
    //     props.formdata.style["Breakpoint"]["Tab"]["StartValue"]=endValueOfBox;
    //   }
    // }

    if(currentInputValue > 10000){
      setSelectedIndexAfterEdit(index);
    }else{
      setSelectedIndexAfterEdit();
    }
    setStartValueOfBox();
    setEndValueOfBox();
    setStartValueInput(false);
    setEndValueInput(false);
    updatedComponentInFormState();
    setChangeInputValueOfBox(false);
    setSelectedIndex();
  }

  function editDoneHandler(index){
   
    let breakpoints = props?.formdata?.style?.Breakpoints;
    let breakpoint = props?.formdata?.style?.Breakpoint;

    if(index === 0){
      breakpoints[index+1].EndValue = '2000';
    } else if(index !== breakpoints.length-1){
      breakpoints[index+1].EndValue = breakpoints[index].EndValue;
    }
    let deleted = breakpoints.splice(index, 1);

    // breakpoints.splice(selectedIndexAfterEdit, 1);
    // console.log("dev...#a1",index,deleted,selectedIndexAfterEdit, startValueOfBox, breakpoints)
    let newBreakpoint = {
      "StartValue" : startValueOfBox,
      // "device" : "Custom"
    }
    if(deleted?.[0]?.["device"]){
      newBreakpoint["device"] = deleted[0]["device"];
    }
    let customBreakPoint = {
      "StartValue" : startValueOfBox
    }
   
    let isLast = true;
    let insertIndex = 0;

    for(let i=0; i<breakpoints.length; i++){
      if(i===0 && parseInt(breakpoints[i]["StartValue"]) < parseInt(startValueOfBox)){
        newBreakpoint["EndValue"] = '2000';
        customBreakPoint["EndValue"] = '2000';
        breakpoints[i]["EndValue"] = newBreakpoint["StartValue"]; 
        isLast = false;
        insertIndex = i;
        break;
      } else if(i!==0 && parseInt(breakpoints[i]["StartValue"]) < parseInt(startValueOfBox)){
        newBreakpoint["EndValue"] = breakpoints[i]["EndValue"];
        customBreakPoint["EndValue"] = breakpoints[i]["EndValue"];
        breakpoints[i]["EndValue"] = newBreakpoint["StartValue"]; 
        isLast = false;
        insertIndex = i;
        break;
      }
    }
    if(isLast){
      newBreakpoint["EndValue"] = breakpoints[breakpoints.length-1]["StartValue"];
      customBreakPoint["EndValue"] = breakpoints[breakpoints.length-1]["StartValue"];
      breakpoints.push(newBreakpoint);
    } else {
      breakpoints.splice(insertIndex, 0, newBreakpoint);
    }
    
    breakpoint = {...breakpoint, "Custom":customBreakPoint}
    
    // console.log("dev...#a2",breakpoint, newBreakpoint,  breakpoints, props.formdata, props.formdata.id, props?.formdata?.style?.Breakpoints);
    updatedComponentInFormState(props.formdata.id, props.formdata);
    setChange(!change);
    setEdit(false);

    if(currentInputValue > 10000){
      setSelectedIndexAfterEdit(index);
    }else{
      setSelectedIndexAfterEdit();
    }
    setStartValueOfBox();
    setEndValueOfBox();
    setStartValueInput(false);
    setEndValueInput(false);
    updatedComponentInFormState();
    setChangeInputValueOfBox(false);
    setSelectedIndex();
  }


  function selectHandle(){
    setSelectedIndex();
  }

  return (
    <div className={style.longMenuWrapper} id="device_selector_customisebrkpoint">
      <Tooltip
        title={t(`translation:Customise Breakpoint Tooltip Content`)}
        placement={"bottom-start"}
        PopperProps={{
          popperOptions: {
            modifiers: {
              offset: {
                offset: "0px -30px",
              },
            },
          },
        }}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        arrow
      >
        <IconButton
          className={classes.root1}
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Popover
        id="breakpoints-long-menu"
        anchorEl={anchorEl}
        // keepMounted
        open={open}
        onClose={handleClose}
        classes={{ root: classes.popoverRoot ,paper: classes.paper }}
        container={document.getElementById("breakpointsMoreOptions")}
        PaperProps={{
          style: { direction: translationStyles1 ? "rtl" : "ltr" }
        }}
      >

      <div 
        // ref={trapRef} 
        // onLoad={ ()=>{ focusElement( document.querySelector("#device_selector_customisebrkpoint") , 0 ); }} 
        className={style.customiseBreakpoints} role="menuitem" >
          {t('translation:Screen Width')}
          <span className={style.crossBreakpoints}  
            onClick={handleClose}
            onKeyDown={(e)=>{if(e.key==="Enter"){ handleClose() }}}
            tabIndex="0"
          > 
            {/* <Cross/> */}
            <img 
              className={style.defaultImageCross}
              style={translationStyles1?{float:"left"}:null}
              alt="image" 
              src={GreyCross}
            />
          </span>
        </div>

        <div className="DevicesClass">
          <BreakpointsDevices
          selectedDevice={props?.selectedDevice}
          setSelectedDevice={props?.setSelectedDevice}
            containerId={props.containerId}
            formdata={props.formdata}
            setDevice={props.setDevice}
            device={props.device}
          />
        </div>

        <hr style={{ margin: "16px 0" }} />

        <div className={style.customiseBreakpoints} role="menuitem">
          {t('translation:Customise Breakpoints')}
        </div>

        <div  className={style.customise2} role="menuitem" onMouseOver={()=>selectHandle()} >
            <span className={style.customise3}>
              {t('translation:Add_Edit_Delete_Breakpoint')}
            </span>
        </div>
        
       

        {props?.formdata?.style && props?.formdata?.style?.Breakpoints.map((breakPoint,index) => {
          return(
            <>
              { 
              
                <div 
                  tabIndex="0" 
                  onMouseOver={()=>selectDeviceHandler(index)}
                  onFocus={()=>selectDeviceHandler(index)} 
                  className={style.iconDevice} 
                  style={translationStyles1?{marginRight:"8px",display:"flex"}:null}
                >
                  { breakPoint["StartValue"] >= 1000  ?
                    <span className={style.iconDevice2}>{devicesJson[0].optionIcon}</span>  
                  : breakPoint["StartValue"] >= 750 ?
                    <span className={style.iconDevice2}> &nbsp; {devicesJson[1].optionIcon}</span>  
                  : breakPoint["StartValue"] >= 320 ?
                    <span className={style.iconDevice2}> &nbsp; &nbsp;{devicesJson[2].optionIcon}</span> 
                  : <span className={style.iconDevice2}>{devicesJson[0].optionIcon}</span>
                  }
      
                  {selectedIndexAfterEdit === index ?
                    <span className={style.afterEdit} style={translationStyles1?{display:"flex"}:null}>
                      <input  
                        aria-label="Start Value"
                        autoFocus
                        type="text"  
                        placeholder="1"
                        className={style.inputClass}
                        value={
                          changeInputValueOfBox ? 
                            startValueOfBox
                          :
                            breakPoint["StartValue"]
                            // props.formdata && props.formdata.style && props.formdata.style["Breakpoint"][content]["StartValue"]
                        }
                        onChange={(event) => handleInputChange(event)}
                        onBlur={(event)=>handleInputForSmallValue(event,index)}
                        name="score" 
                      /> 
                      &nbsp;
                      {/* <input  
                        type="number"  
                        placeholder="1"
                        className={style.inputClass}
                        value={
                          changeInputValueOfBox ? 
                          endValueOfBox :
                          props.formdata && props.formdata.style && props.formdata.style["Breakpoint"][content]["EndValue"]
                        }
                        onChange={(event)=>handleInputForLargeValue(event,content)} 
                        name="score" 
                      />
                      &nbsp; */}
                      <span>
                        <button onClick={()=>cancelCustom()} className={matches ? style.cancelButtonCustom :style.cancelButtonCustomIpad}>
                          {t('translation:Cancel')}
                        </button>
                        {edit ?
                          <button disabled={!inputInRange} className={style.doneButtonCustom} onClick={()=>editDoneHandler(index)} >
                            {t('translation:Done')}
                          </button> 
                        :
                          <button disabled={!inputInRange} className={style.doneButtonCustom} onClick={()=>doneHandler(index)} >
                            {t('translation:Done')}
                          </button>
                        }
                        
                      </span>
                    </span>
                    :
                    <>
                      {
                      // breakPoint["StartValue"] !== undefined && breakPoint["EndValue"] !== undefined &&
                        <span 
                          className={style.iconDeviceName} 
                          onMouseOver={()=>selectDeviceHandler(index)}
                          onFocus={()=>selectDeviceHandler(index)}
                          tabIndex="0"
                        >
                          {index === 0 ? 
                            <>
                              {breakPoint["StartValue"]}{t("translation:px")}
                                &nbsp;&nbsp;
                              {t(`translation:& more`)}
                            </>
                          :
                            <>
                              {breakPoint["StartValue"]}{t("translation:px")}
                                &nbsp; - &nbsp;
                              {breakPoint["EndValue"]}{t("translation:px")}
                            </>
                          }
                        </span> 
                      }
                    </>
                  }
                  <div className={style.editDelete}>
                    {selectedIndex === index && selectedIndexAfterEdit !== index ?
                      <>   
                        <span 
                        title={t("translation:Edit")}
                         tabIndex="0" 
                         onClick={()=>editPixelForDevice(breakPoint["StartValue"],index)} 
                         onKeyDown={(e)=>{if(e.key==="Enter"){ editPixelForDevice(breakPoint["StartValue"],index) }}} 
                         className={style.spaceEditDelete}
                        >
                          <EditIcon fontSize="small" />
                        </span>
                        {
                          breakPoint["device"] === "Custom" &&
                          <span
                          title={t("translation:Delete")}
                            tabIndex="0" 
                            onClick={()=>deleteDevice(index)}
                            onKeyDown={(e)=>{if(e.key==="Enter"){ deleteDevice(index) }}} 
                          >
                            <SvgDeleteWhiteIcon style={{ stroke: "#ff0000" }} />
                          </span>
                        }
                      </>
                    : null
                    }

                  </div>
                </div> 
              }
            </>
          )
        })}
      </Popover>
    </div>
  );
}
